import { ImageLibraryItem } from "@/shared/imageLibrary/types";

const extensionByType: Record<string, string> = {
  "image/png": "png",
  "image/webp": "webp",
  "image/jpeg": "jpg",
};

/**
 * Library images are plain urls while we store Cloudinary ids, so a library
 * image is downloaded and uploaded like a normal file. AI images are linked by
 * their cloudinary_id instead, see isAiImage.
 */
const libraryImageToFile = async (image: ImageLibraryItem) => {
  const response = await fetch(image.url);
  if (!response.ok) throw new Error(`Could not download ${image.url}`);
  const blob = await response.blob();
  const type = blob.type || "image/jpeg";
  return new window.File([blob], `${image.name}.${extensionByType[type] ?? "jpg"}`, { type });
};

export default libraryImageToFile;
